import Card from "components/card";
import Switch from "components/switch";
import { useNotifications } from "context/NotificationContext";

function Notification() {
  const { notifications, updateNotificationStatus } = useNotifications();

  const handleSwitchChange = (id: string, checked: boolean) => {
    updateNotificationStatus(id, checked);
  };

  return (
    <Card extra={"w-full p-4 h-full"}>
      <div className="mb-8 w-full">
        <h4 className="text-xl font-bold text-navy-700">
          Notificações
        </h4>
      </div>

      <div className="flex flex-col">
        {notifications.map((notif) => (
          <div key={notif.id} className="mt-4 flex items-center gap-3">
            <Switch
              id={notif.id}
              color="person"
              checked={notif.checked}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                handleSwitchChange(notif.id, e.target.checked)
              }
            />
            <label
              htmlFor={notif.id}
              className="text-base font-medium text-navy-700"
            >
              {notif.label}
            </label>
          </div>
        ))}
      </div>
    </Card>
  );
}

export default Notification;
